import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useParams } from "react-router"
import { useDialog } from "lib/@hooks/useDialog"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { GroupStatus } from "authoring/lib/enum/group-status.mjs"
import { isUnlockableGroup } from "authoring/lib/enum/unlockable-group-types.mjs"
import { unlockGroup } from "../group/controller/unlock-group"
import { UnlockGroupDialog } from "../group/components/unlock-group-dialog"

export function UnlockGroupButton() {
    const { projectId, groupId } = useParams()
    const { group, project } = useBoundContext()
    const unlockDialog = useDialog(<UnlockGroupDialog groupName={group?.name} />)

    if (group?.status !== GroupStatus.APPLIED) return null
    if (!isUnlockableGroup(group)) return null

    const sentToLegacy = isLockedToLegacy(project?.phase)

    return (
        <Button
            data-cy="unlock-group-button"
            startIcon={<Iconify icon="material-symbols:lock-open-outline" />}
            variant="outlined"
            disabled={sentToLegacy}
            onClick={handleClick}
        >
            Unlock
        </Button>
    )

    async function handleClick() {
        try {
            const confirmed = await unlockDialog()
            if (!confirmed) return

            const result = await unlockGroup({ projectId, groupId })
            if (!result?.success) {
                errorSnackbar(result?.error || "Failed to unlock group")
                return
            }

            successSnackbar("Group unlocked")
        } catch (error) {
            console.error(error)
            errorSnackbar("Unexpected error when unlocking group")
        }
    }
}
